import { gAService } from 'eTip--common';
import { ILoggingService } from './loggingService';

export interface IRenderTelemetryService {
    start(): number;
    finish(context: number): void;
}

export interface IGlobalRenderTelemetryService {
    start(): void;
    finish(): void;
}

export const createRenderTelemetryService = (description: string, descriptionForGA: string, loggingService: ILoggingService): IRenderTelemetryService => {

    let index = 0;
    let started: Date = null;

    return {
        start: () => {
            index = index + 1;
            if (index === Number.MAX_VALUE) {
                index = 0;
            }
            started = new Date();
            loggingService.info(description + " start", index);
            return index;
        },
        finish: (context: number) => {
            var diff: number;
            if (started) {
                diff = new Date().getTime() - started.getTime();
            } else {
                diff = -1;
            }
            loggingService.info(description + " finish", diff, context, index);
            gAService.sendTiming("Render intervals", descriptionForGA, diff);
        }
    };
};

export const createGlobalRenderTelemetryService = (description: string, descriptionForGA: string, loggingService: ILoggingService): IGlobalRenderTelemetryService => {
    let index = 0;
    let started: Date = null;
    let lastFinished = 0;

    return {
        start: () => {
            index = index + 1;
            if (index === Number.MAX_VALUE) {
                index = 1;
            }
            started = new Date();
            loggingService.info(description + " start", index);
        },
        finish: () => {
            if (lastFinished !== index) {
                var diff: number;
                if (started) {
                    diff = new Date().getTime() - started.getTime();
                } else {
                    diff = -1;
                }
                loggingService.info(description + " finish", diff, index);
                lastFinished = index;
                gAService.sendTiming("Render intervals", descriptionForGA, diff);
            }
        }
    };
}
